// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-fe05db1c] .otherDiv{width:100%}[data-v-fe05db1c] .otherDiv>span{flex:auto}.chart[data-v-fe05db1c],[data-v-fe05db1c] .otherDiv span:nth-child(2){flex:0 0 50%;margin-left:5px}.chart[data-v-fe05db1c]{height:500px}.chart.active[data-v-fe05db1c]{margin:0 auto;flex:0 0 50%;height:500px}.google-visualization-tooltip[data-v-fe05db1c]{pointer-events:none}", ""]);
// Exports
module.exports = exports;
